import React, { useEffect, useState } from "react";
import { FiArrowUp } from "react-icons/fi";
import { useSelector } from "react-redux";
import { selectThemeColor } from "../redux/portfolioSlice";

export default function ScrollToTop() {
  const themeColor = useSelector(selectThemeColor);
  const [isVisible, setIsVisible] = useState(false);
  // Top: 0 takes us all the way back to the top of the page
  // Behavior: smooth keeps it smooth!
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    // Button is displayed after scrolling for 500 pixels
    const toggleVisibility = () => {
      if (window.pageYOffset > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <>
      {isVisible && (
          <div
            onClick={scrollToTop}
            className="scroll_up"
            data-aos="fade-left"
            data-aos-duration="1200"
            data-aos-delay="200"
            style={{ backgroundColor: themeColor["--themeColor"] }}
          >
            <FiArrowUp style={{ color: '#d1d1d1' }} />
          </div>
      )}
    </>
  );
}
